import { Spinner } from '../ui/Spinner';

/** Shown while a route chunk loads. Intentionally quiet - no layout shift. */
export function RouteFallback() {
  return (
    <div className="grid min-h-[60dvh] place-items-center">
      <Spinner className="size-6 text-muted" label="Chargement de la page" />
    </div>
  );
}
